/**
 * NS Investigation
 */

export const NS_GET_INVEST_LIST_DATA = 'NS_GET_INVEST_LIST_DATA';
export const NS_GET_INVEST_LIST_DATA_SUCCESS =
  'NS_GET_INVEST_LIST_DATA_SUCCESS';
export const NS_GET_INVEST_LIST_DATA_FAIL = 'NS_GET_INVEST_LIST_DATA_FAIL';

export const NS_DOWNLOAD_SELECTED_LIST = 'NS_DOWNLOAD_SELECTED_LIST';
export const NS_DOWNLOAD_SELECTED_LIST_SUCCESS =
  'NS_DOWNLOAD_SELECTED_LIST_SUCCESS';
export const NS_DOWNLOAD_SELECTED_LIST_FAIL = 'NS_DOWNLOAD_SELECTED_LIST_FAIL';

export const NS_GET_CUSTOMER_TYPE_LIST = 'NS_GET_CUSTOMER_TYPE_LIST';
export const NS_GET_CUSTOMER_TYPE_LIST_SUCCESS =
  'NS_GET_CUSTOMER_TYPE_LIST_SUCCESS';
export const NS_GET_CUSTOMER_TYPE_LIST_FAIL = 'NS_GET_CUSTOMER_TYPE_LIST_FAIL';

export const NS_SEND_TO_CM = 'NS_SEND_TO_CM';
export const NS_SEND_TO_CM_SUCCESS = 'NS_SEND_TO_CM_SUCCESS';
export const NS_SEND_TO_CM_FAIL = 'NS_SEND_TO_CM_FAIL';

export const NS_GET_ALERT_HITS_DATA = 'NS_GET_ALERT_HITS_DATA';
export const NS_GET_ALERT_HITS_DATA_SUCCESS = 'NS_GET_ALERT_HITS_DATA_SUCCESS';
export const NS_GET_ALERT_HITS_DATA_FAIL = 'NS_GET_ALERT_HITS_DATA_FAIL';

export const getInvestListData = (payload) => {
  return {
    type: NS_GET_INVEST_LIST_DATA,
    payload
  };
};

export const getInvestListDataSuccess = (payload) => {
  return {
    type: NS_GET_INVEST_LIST_DATA_SUCCESS,
    payload
  };
};

export const getInvestListDataFail = (payload) => {
  return {
    type: NS_GET_INVEST_LIST_DATA_FAIL,
    payload
  };
};

export const getAlertHitsData = (payload) => {
  return {
    type: NS_GET_ALERT_HITS_DATA,
    payload
  };
};

export const getAlertHitsDataSuccess = (payload) => {
  return {
    type: NS_GET_ALERT_HITS_DATA_SUCCESS,
    payload
  };
};

export const downloadSelectedAlerts = (payload) => {
  return {
    type: NS_DOWNLOAD_SELECTED_LIST,
    payload
  };
};

export const downloadSelectedAlertsSuccess = (payload) => {
  return {
    type: NS_DOWNLOAD_SELECTED_LIST_SUCCESS,
    payload
  };
};

export const downloadSelectedAlertsFail = (payload) => {
  return {
    type: NS_DOWNLOAD_SELECTED_LIST_FAIL,
    payload
  };
};

export const sendToCMAlerts = (payload) => {
  return {
    type: NS_SEND_TO_CM,
    payload
  };
};

export const sendToCMAlertsSuccess = (isFromAlertList) => {
  return {
    type: NS_SEND_TO_CM_SUCCESS,
    payload: { isFromAlertList }
  };
};

export const sendToCMAlertsFail = (payload) => {
  return {
    type: NS_SEND_TO_CM_FAIL,
    payload
  };
};

export const getCustomerTypesSegment = (payload) => {
  return {
    type: NS_GET_CUSTOMER_TYPE_LIST,
    payload
  };
};

export const getCustomerTypesSegmentSuccess = (payload) => {
  return {
    type: NS_GET_CUSTOMER_TYPE_LIST_SUCCESS,
    payload
  };
};

export const getCustomerTypesSegmentFail = (payload) => {
  return {
    type: NS_GET_CUSTOMER_TYPE_LIST_FAIL,
    payload
  };
};
